import type { ConfirmationModalProps } from '../../types/modals'
/** ConfirmDialog wrapper preserving legacy ActionButtons / Impersonation API. */
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'


/** Cheap heuristic: the legacy ActionButtons flow passes raw HTML in `message`
 *  for the Cancel dialog (with `<ul>` / `<li>` / `<b>`). Detect that and route
 *  through `htmlMessage` so it renders instead of showing tags as plain text. */
function looksLikeHtml(value: string): boolean {
  return /<\/?[a-z][\s\S]*?>/i.test(value)
}

export function ConfirmationModal({
  title,
  message,
  positiveTitle = 'Yes',
  negativeTitle = 'No',
  onConfirm,
  onCancel,
  onClose,
  presentation = 'default',
  testIdPrefix = 'application-modal-confirmation',
}: ConfirmationModalProps) {
  const isHtml = typeof message === 'string' && looksLikeHtml(message)
  return (
    <ConfirmDialog
      isOpen={true}
      title={title}
      message={isHtml ? '' : message}
      htmlMessage={isHtml ? message : undefined}
      primaryLabel={positiveTitle}
      secondaryLabel={negativeTitle}
      onPrimary={onConfirm}
      onSecondary={onCancel ?? onClose}
      onDismiss={onClose}
      presentation={presentation}
      overlayDataTestId={testIdPrefix}
      primaryButtonDataTestId={`${testIdPrefix}-confirm-btn`}
      secondaryButtonDataTestId={`${testIdPrefix}-cancel-btn`}
      closeButtonDataTestId={`${testIdPrefix}-close-btn`}
    />
  )
}
